module.exports = __webpack_public_path__ + "img/consult.b493e44a.png";